import React from 'react'
import Guests from '../front-components/Guests'
import Vendors from '../front-components/Vendors'
import BridesGrooms from '../front-components/BridesGrooms'

const OpeningScreen = () => {
  return (
    <>
    <BridesGrooms />
    <Guests />
    <Vendors />
    
    </>
    
  )
}

export default OpeningScreen
